<div class="border-2 border-gray-200">
  <app-pan-section-header title="Discussion"></app-pan-section-header>

  @if (isLoading()) {
    <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading... </app-pan-blank-slate>
  } @else {
    @for (comment of comments(); track $index) {
      <app-discussion-thread-comment
        [comment]="comment"
        class="border-b-gray-200"
        [class.border-b-2]="!$last"
      ></app-discussion-thread-comment>
    } @empty {
      <app-pan-blank-slate> There are no comments yet. </app-pan-blank-slate>
    }

    @if (canAddComments()) {
      <app-discussion-thread-comment-adder (addComment)="createNewComment($event)" class="mt-4 border-t-2 border-t-gray-200">
      </app-discussion-thread-comment-adder>
    }
  }
</div>
